<template>
  <div class="text-center">
    <p class="mb-1"><i class="fas fa-spinner fa-spin" /></p>
    <p>Carregando dados</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingData',
}
</script>
